<template>
  <div id="footer">
    <!--<div class="news">-->
    <!--<p class="newsTitle">最新资讯</p>-->
    <!--<ul class="newsList">-->
    <!--<template v-for="item in newsList">-->
    <!--<li class="list">-->
    <!--<a :title="decodeURIComponent(item.title)" :href="'/study/newslist?id='+item.id" target="_blank">{{decodeURIComponent(item.title)}}</a>-->
    <!--</li>-->
    <!--</template>-->
    <!--</ul>-->
    <!--</div>-->
    <!--<div class="line" style="border-bottom: 1px solid #4F4E4E;height:0;"></div>-->
    <div class="about">
      <ul class="text-section home-part">
        <li class="titleInfo">首页精选</li>
        <li><a class="border" href="/">返回首页</a></li>
      </ul>
      <ul class="text-section about-part">
        <li class="titleInfo">关于我们</li>
        <li>
          <a class="border" href="/study/about#introduce-section">产品介绍</a>
        </li>
        <li>
          <a class="border" href="/study/about#advantage-section">功能特色</a>
        </li>
      </ul>
      <ul class="text-section contact-part">
        <li class="titleInfo">联系我们</li>
        <li>
          <a class="border" href="/study/about#contact-section">公司地址</a>
        </li>
        <li>
          <a class="border" href="/study/about#contact-section">线上联系</a>
        </li>
      </ul>
      <div class="qr-wrapper">
        <img src="./qr-code.jpg" alt="二维码" width="108" height="108">
        <p class="qr-hint">下载全优在线App</p>
      </div>
      <div class="qr-wrapper">
        <img src="./qr-code.jpg" alt="二维码" width="108" height="108">
        <p class="qr-hint">微信公众号</p>
      </div>
      <div class="service-section">
        <p class="service-title tele">客服电话：</p>
        <p class="servive-num">0571-28815085</p>
        <p class="service-title qq">QQ：
          <a target="_blank"
             class="qqlink"
             href="https://wpa.qq.com/msgrd?v=3&uin=2480161624&site=qq&menu=yes">
            <img border="0" src="https://wpa.qq.com/pa?p=2:2480161624:41" alt="联系我们" title="联系我们"/>
          </a></p>
        <p class="servive-num">2480161624</p>
      </div>
    </div>
    <div class="line" style="border-bottom: 1px solid #4F4E4E;height:0;"></div>
    <div class="link">
    <!--<span class="paratitle">-->
      <!--友情链接：-->
    <!--</span>-->
      <!--<ul class="ul">-->
        <!--<template v-for="item in linkList">-->
          <!--<li class="li">-->
            <!--<a :href="item.link" target="_blank">{{decodeURIComponent(item.name)}}</a>-->
          <!--</li>-->
        <!--</template>-->
      <!--</ul>-->
      <p class="para">
        杭州九漫信息技术有限公司版权所有-浙ICP备09095240号-3
      </p>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  export default{
    data(){
      return {
        id: (() => loadLocal('id', false))(),
        newsList: [],
        linkList: [],
      }
    },
    methods: {
      QueryNews(){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'News',
            a: 'QueryNewsList',
            id: this.id,
            pageno: 1,
            pagesize: 8,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.newsList = response.list;
          }
        }).catch((err) => {
        })
      },
      QueryLinksList(){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'News',
            a: 'QueryLinksList',
            id: this.id,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.linkList = response.list;
          }
        }).catch((err) => {
        })
      }
    },
    created(){
      // this.QueryNews();
      // this.QueryLinksList();
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  #footer {
    clear: both;
    font-size: 0;
    box-sizing: border-box;
    background: #2D2D2D;
  }

  #footer .news {
    margin: 0 auto;
    width: 1226px;
    padding: 43px 0 23px;
    box-sizing: border-box;
  }

  #footer .news .newsTitle {
    margin-bottom: 20px;
    height: 20px;
    line-height: 20px;
    padding-left: 35px;
    color: #fff;
    font-size: 14px;
    background: url('./news.png') no-repeat top left / 20px 20px;
  }

  #footer .news .newsList .list {
    display: inline-block;
    margin: 0 84px 20px 0;
    width: 243px;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
  }

  #footer .news .newsList .list:nth-child(4n) {
    margin-right: 0;
  }

  #footer .news .newsList .list a {
    color: #ccc;
    display: block;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  #footer .news .newsList .list a:hover {
    color: #fff;
  }

  #footer .about {
    margin: 0 auto;
    padding-top: 37px;
    height: 214px;
    width: 1226px;
    box-sizing: border-box;
    overflow: visible;
  }

  #footer .about .text-section {
    margin-right: 66px;
    width: 86px;
    float: left;
    padding-left: 30px;
    box-sizing: border-box;
  }

  #footer .about .text-section li, #footer .about .text-section li a {
    margin-bottom: 20px;
    font-size: 12px;
    color: #cccccc;
    line-height: 17px;
    padding-bottom: 6px;
  }

  #footer .about .text-section li.titleInfo {
    position: relative;
    top: 3px;
    padding-bottom: 0px;
    color: #fff;
    font-size: 14px;
  }

  #footer .about .text-section li a.border:hover {
    border-bottom: 1px solid #fff;
    color: #fff;
  }

  #footer .about .text-section.home-part {
    background: url('./home.png') no-repeat top left / 20px 20px;
  }

  #footer .about .text-section.about-part {
    background: url('./about.png') no-repeat top left / 20px 20px;
  }

  #footer .about .text-section.contact-part {
    margin-right: 153px;
    background: url('./telephone.png') no-repeat top left / 20px 20px;
  }

  #footer .about .qr-wrapper {
    float: left;
    margin-right: 80px;
    width: 108px;
    font-size: 0;
  }

  #footer .about .qr-wrapper .qr-hint {
    margin-top: 10px;
    width: 120px;
    margin-left: -10px;
    line-height: 20px;
    color: #fff;
    font-size: 14px;
    text-align: center;
  }

  #footer .about .service-section {
    float: right;
    width: 198px;

  }

  #footer .about .service-section .service-title {
    margin-bottom: 20px;
    padding-left: 30px;
    line-height: 20px;
    height: 20px;
    font-size: 14px;
    color: #fff;
  }

  #footer .about .service-section .service-title.tele {
    background: url('./telephone.png') no-repeat top left / 20px 20px;
  }

  #footer .about .service-section .service-title.qq {
    background: url('./qq.png') no-repeat top left / 20px 20px;
  }

  #footer .about .service-section .servive-num {
    margin-bottom: 14px;
    line-height: 28px;
    height: 28px;
    font-size: 24px;
    color: #fff;
  }

  #footer .link {
    margin: 0 auto;
    padding-top: 34px;
    height: 130px;
    width: 1226px;
    box-sizing: border-box;
    overflow: visible;
  }

  #footer .link .para {
    line-height: 20px;
    margin-bottom: 20px;
    font-size: 14px;
    color: #ccc;
  }

  #footer .link .paratitle {
    display: inline-block;
    line-height: 20px;
    margin-bottom: 20px;
    font-size: 14px;
    color: #ccc;
    vertical-align: top;
  }

  #footer .link .ul {
    display: inline-block;
    line-height: 20px;
    margin-bottom: 20px;
    color: #ccc;
  }

  #footer .link .ul .li {
    float: left;
    font-size: 14px;
    padding: 0 10px;
    position: relative;
  }

  #footer .link .ul .li:after {
    position: absolute;
    top: 4px;
    height: 13px;
    right: 0;
    content: '';
    width: 0;
    border-left: solid #ccc 1px;
  }

  #footer .link .ul .li a {
    color: #ccc;
  }

  #footer .link .ul .li a:hover {
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/footnav/FootNav.vue